export default __webpack_public_path__ + "static/media/owl-looks-ahead.3bb024b2.jpg";